import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { View } from "react-native";
import { cn } from "./utils";

const SeekSlider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    trackColor?: string;
    trackBackgroundColor?: string;
    disabled?: boolean;
    containerClassName?: string;
  }
>(
  (
    {
      className,
      trackColor,
      trackBackgroundColor,
      disabled,
      containerClassName,
      onValueChange,
      value,
      ...props
    },
    ref
  ) => {
    const handleTrackClick = async (
      event: React.MouseEvent<HTMLDivElement>
    ) => {
      if (disabled) return;

      const trackElement = event.currentTarget;
      const rect = trackElement.getBoundingClientRect();
      const offsetX = event.clientX - rect.left;
      const percentage = (offsetX / rect.width) * 100;

      // Ensure the percentage is between 0 and 100
      const clampedPercentage = Math.max(0, Math.min(100, percentage));

      // Call onValueChange with the new value
      onValueChange?.([clampedPercentage]);

      // Stop propagation to prevent conflicts with other handlers
      event.stopPropagation();
    };

    return (
      <View className={cn("relative", containerClassName)}>
        <SliderPrimitive.Root
          ref={ref}
          className={cn(
            "relative flex w-full touch-none select-none items-center cursor-pointer py-4",
            className
          )}
          {...props}
          disabled={disabled}
          value={value}
          onValueChange={onValueChange}
        >
          <SliderPrimitive.Track
            className={cn(
              "relative h-1.5 w-full grow overflow-hidden rounded-full bg-gray-200"
            )}
            style={{
              ...(trackBackgroundColor && {
                backgroundColor: trackBackgroundColor,
              }),
            }}
            onClick={handleTrackClick}
          >
            <SliderPrimitive.Range
              className="absolute h-full bg-gray-800"
              style={{
                ...(trackColor && { backgroundColor: trackColor }),
              }}
            />
          </SliderPrimitive.Track>
        </SliderPrimitive.Root>
      </View>
    );
  }
);
SeekSlider.displayName = SliderPrimitive.Root.displayName;

export { SeekSlider };
